<template>      
<v-flex xs12 sm12 md12 lg12 xl12 class="signup">
  <v-container>
    <div class='pattern'></div>       
    <v-layout class="tiranaranja" justify-end >       
        <img class="hidden-xs-only" src="elementos-pantalla-azulcielo-14.png" >
        <img class="hidden-sm-and-up" src="elementos-pantalla-azulcielo-14.png" height="150px" style="margin-top:30%">
    </v-layout>

    <v-layout class="divlogin" row justify-center>
      <v-form v-model="valid" class="formlogin" style="background-color:#263971; width:90%; border-radius:20px">
        <v-container>
          <v-layout row wrap justify-center class="pt-3">
            <v-flex xs12 sm12 md4 lg5>
              <v-text-field
                name="email"
                v-model="email"
                :rules="emailRules"
                label="usuario@gmail.com"
                required
                solo
                prepend-inner-icon="person"
                flat
                style="background:white; border-radius:8px" class="pa-1"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm12 md4 lg5>   
              <v-text-field
                v-model="password"
                :append-icon="show2 ? 'visibility' : 'visibility_off'"
                :rules="[rules.required]"
                :type="show2 ? 'text' : 'password'"
                name="input-10-2"
                label="Contraseña"
                style="background:white; border-radius:8px;"
                hint="At least 6 characters"
                solo
                prepend-inner-icon="lock"
                flat
                class="input-group--focused pa-1"
                @click:append="show2 = !show2"                    
              ></v-text-field>
              <br>
            </v-flex>
          </v-layout>


          <v-layout justify-center>
            <v-dialog
              v-model="dialog"
              width="450"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  large
                  :rules="emailRules"
                  class="text-none loginbutton"
                  color="#4ba96c"
                  dark
                  @click="verifyempty()"
                >
                  Crear Cuenta
                </v-btn>
              </template>

              <v-card style="border-radius:10px" class="pb-5">
                <v-card-actions>
                  <v-spacer></v-spacer>
                <v-btn  fab flat color="#B4347E" small @click="dialog = false">
                  <v-icon x-large>cancel</v-icon>              
                </v-btn>
                </v-card-actions>

                <v-card-title 
                  class="headline white lighten-2 justify-center"
                  primary-title
                  style="color:#528AC3;font-family:Poppins!important;font-size:1vw;font-weight:500"
                >
                  ¿Tu correo es correcto?
                </v-card-title>
              
              <v-layout justify-center>
              <v-flex xs11 md10 lg10 >
                <v-text-field                
                  v-model="email2"
                  :rules="emailRules"
                  :label="email"
                  required
                  solo
                  prepend-inner-icon="person"
                  flat
                  disabled
                  style="background-color:#ebf1f8; border-radius:8px;" class="pa-2 checkcorreo"
                ></v-text-field>
              </v-flex>
              </v-layout>


              <v-layout row wrap justify-space-around>
                <v-btn
                  large
                  color="#558BC3"
                  @click="saveinfo()"
                  class="text-none loginbutton"
                  style="color:white"
                >
                  SI
                </v-btn>

                <v-btn
                  large            
                  color="#558BC3"
                  @click="dialog = false"
                  class="text-none loginbutton"
                  style="color:white;"
                >
                  NO
                </v-btn>              
              </v-layout>
            </v-card>
            
          </v-dialog>
            </v-layout>
          </v-container>
        </v-form>
    </v-layout>

  <v-layout class="pl-5 mrosa">
    <img class="hidden-xs-only" src="mrosa.png">
    <img class="hidden-sm-and-up" src="mrosa.png" height="150px">
  </v-layout>    
</v-container>
</v-flex>

</template>

<script>


export default {    
    data () {
      return {
        show2: false,
        dialog:false,
        valid:false,
        password: '',
        rules: {
          required: value => !!value || 'Obligatorio',
          //min: v => v.length >= 8 || 'Min 8 characters',
          //emailMatch: () => ('The email and password you entered don\'t match')
        },
        email:'',
        email2:'',
        emailRules: [
          v => !!v || 'Obligatorio',
          v => /.+@.+/.test(v) || 'E-mail must be valid'
        ]
      }      
    },
    methods:{
      verifyempty: function(){
        var email = this.email.trim();
        email = email.toLowerCase();
        var password = this.password;
        var patron=/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/ ;

        if(this.email=="" || this.password==""){
          alert("Completar informacion");          
        }else if(email.search(patron)!=0){
          alert("Direccion de correo incorrecta");
        }else if(password.length<=5){
          alert("Ingresa una contraseña mas larga");        
        }else if(email.search(patron)==0){
          this.dialog=true
        }
      },
      saveinfo: function(){
        //alert("hola")
        if (typeof(Storage) !== 'undefined') {
          let user = this.email
          localStorage.User = user
          this.$router.push('/confirm_password')  
        } else {
          alert("localstoragge no funciona")
        }
          
        },

        
        
        
      
    }
    
}
</script>


<style>

.signup {
  text-align: left;
  height: 100%;
  width: 100%;
  z-index: 1;
  background-color:#2F478D;;

}

.signup img{
    z-index: 2;
}

.pattern {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: url('../assets/PATTERN.png') center center;
  opacity: .1;
  width: 100%;
  height: 100%;
}

theme--light.v-icon{
  color:#B4347E;
}



@media (min-width:750px){
  .loginbutton{
      border-radius:10px;
      color:white; 
      font-family:Poppins;
      font-weight:500;
      font-size:1.5vw;
  }
}

@media (max-width:750px){
  .loginbutton{
      border-radius:10px;
      color:white; 
      font-family:Poppins;
      font-weight:500;
      font-size:5vw;
  }
}

@media (min-width: 1200px){
  .formlogin{
    padding: 50px 50px 50px 50px;
  }
  .mrosa{
   margin-top:-100px;
  }
  .tiranaranja{
    margin-right:50px;
  }
  .divlogin{
    margin-top:-100px;
  }
}

@media (min-width: 370px) and (max-width: 750px){
  .mrosa{
   margin-top:-30px;
   
  }
  .divlogin{
    margin-top: -50px
  }
}
</style>